<template>
  <div class="tv-group-list">
    <div
      v-if="groupListDatas && groupListDatas.length"
      class="tool-wrap"
    >
      <!-- 创建组合 -->
      <a-button
        type="primary"
        @click="handleAdd"
      >
        {{ $t('message[1927]') }}
      </a-button>
    </div>
    <a-table
      v-if="groupListDatas && groupListDatas.length"
      row-key="id"
      :columns="groupColumns"
      :data-source="groupListDatas"
      :loading="loading"
      :pagination="false"
      :locale="{
        'emptyText': $t('message[1967]')
      }"
    >
      <template
        slot="name"
        slot-scope="text, record"
      >
        <span>{{ text }}</span>
        <span
          class="status-text"
          :class="{'fs-green': record.status === 1}"
        >{{ record.status === -1 ? listStatusName[1] : record.status === 1 ? listStatusName[0] : '' }}</span>
      </template>
      <template
        slot="action"
        slot-scope="text,record"
      >
        <a
          v-if="record.status !== -1"
          @click="handleCode(record)"
        >
          {{ $t('message[1786]') }}
        </a>
        <a
          v-if="record.status !== -1"
          href="javascript:;"
          @click="handleEdit(record)"
        >{{ $t('message[36]') }}</a>
        <a @click="handleClose(record)">
          {{ record.status === -1 ? statusName[1] : record.status === 1 ? statusName[0] : '' }}
        </a>
        <a @click="handleDelete(record)">
          {{ $t('message[962]') }}
        </a>
      </template>
    </a-table>
    <div
      v-if="loading === false && !groupListDatas.length"
      class="empty-box"
    >
      <img
        src="@/assets/images/logo-gray.png"
        alt=""
        class="logo"
      >
      <p>{{ $t('message[1967]') }}</p>
      <!-- 创建组合 -->
      <a-button
        type="primary"
        class="add-btn2"
        @click="handleAdd"
      >
        {{ $t('message[1927]') }}
      </a-button>
    </div>
    <code-modal
      :visible.sync="showCodeModal"
      :preview-code="previewCode"
      :title="$t('message[1786]')"
    />
    <group-modal
      :visible.sync="showGroupModal"
      :groupid="currentGroupid"
      @successAfter="successAfter"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CodeModal from './CodeModal'
import GroupModal from './GroupModal'

export default {
  components: {
    CodeModal,
    GroupModal
  },
  data () {
    return {
      showCodeModal: false,
      showGroupModal: false,
      previewCode: '',
      currentGroupid: ''
    }
  },
  computed: {
    ...mapState('config/tv', ['groupColumns', 'groupListDatas', 'listDatas', 'loading', 'allConfig']),

    typeMap () {
      let { type = {} } = this.allConfig || {}

      return type
    },
    statusName () {
      let str = this.$t('message[1204]')
      let arr = str.split('|')
      return arr
    },
    listStatusName () {
      let str = this.$t('message[1818]')
      let arr = str.split('|')
      return arr
    }
  },
  async created () {
    await this.getTvGroupList()
  },
  methods: {
    ...mapActions('config/tv', [
      'getTvGroupList',
      'delConfig',
      'closeConfig',
      'openConfig',
      'fetchCode'
    ]),
    handleAdd () {
      this.showGroupModal = true
      this.currentGroupid = ''
    },

    handleEdit (record) {
      this.showGroupModal = true
      this.currentGroupid = record.id
    },
    /**
     * 获取code
     */
    async handleCode (record) {
      const chain = await this.fetchCode({ id: record.id, type: 2 })
      chain
        .onSuccess(res => {
          const { code = '' } = res
          this.showCodeModal = true
          this.previewCode = code
        })
      this.showCodeModal = true
    },
    /**
     * 启用/停用
     */
    async handleClose (record) {
      let { status } = record // 停用: -1  启用: 1
      let chain
      if (status === -1) {
        chain = await this.openConfig({ id: record.id, type: 2 })
      } else if (status === 1) {
        chain = await this.closeConfig({ id: record.id, type: 2 })
      }

      chain
        .onSuccess(res => {
          this.getTvGroupList()
        })
    },
    /**
     * 删除组合
     */
    async handleDelete (record) {
      this.$confirm({
        title: this.$t('message[1933]'), // '删除当前组合',
        content: this.$t('message[1934]'), // '删除后，正在使用的组合将无法正常使用，组合中的屏幕不会同步删除。并且确定要删除吗？',
        closable: true,
        okText: this.$t('message[915]'), // 确定
        okType: 'primary',
        cancelText: this.$t('message[896]'), // 取消
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.delConfig({ id: record.id, type: 2 })
          chain
            .onSuccess(res => {
              this.getTvGroupList()
            })
        }
      })
    },
    successAfter () {
      this.getTvGroupList()
    }
  }
}
</script>

<style scoped lang="scss">
.tv-group-list {
  margin-bottom: 60px;
}
.ant-table-wrapper ::v-deep {
  .ant-table-tbody > tr > td {
    vertical-align: top;
  }
}
.status-text{
  position: relative;
  height: 20px;
  line-height: 20px;
  margin-left: 12px;
  padding: 0 4px 0 11px;
  font-size: 12px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #EBEBEB;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 4px;
    bottom: 0;
    width: 4px;
    height: 4px;
    margin: auto 0;
    background-color: #E0E0E0;
    border-radius: 4px;
  }
  &.fs-green::before {
    background-color: #42C27E;
  }
}
a {
  margin-right: 16px;
  &:last-child {
    margin-right: 0;
  }
}
.tool-wrap {
  margin-bottom: 24px;
}

.empty-box {
  text-align: center;
  .logo {
    width: 40px;
    height: 40px;
    margin: 120px auto 24px;
    background-size: 100%;
  }
  p {
    color: #b3b3b3;
  }
  .add-btn2 {
    display: block;
    margin: 24px auto;
  }
}
</style>
